/**
 * @generated SignedSource<<8abea3759e14de60f07aee4bea638a89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ToolbarButtonAssignees_roles$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemRoles_roles">;
  readonly " $fragmentType": "ToolbarButtonAssignees_roles";
}>;
export type ToolbarButtonAssignees_roles$key = ReadonlyArray<{
  readonly " $data"?: ToolbarButtonAssignees_roles$data;
  readonly " $fragmentSpreads": FragmentRefs<"ToolbarButtonAssignees_roles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ToolbarButtonAssignees_roles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListItemRoles_roles"
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};

(node as any).hash = "6138c41d0b96b20d1dc3da1f2e2c507e";

export default node;
